export const ESYSTEM_SETTING = Object.freeze({
  MAIN: "/system-setting",
  KILL_SWITCH: "system-setting/type/kill-switch",
  AGENT_DASHBOARD_TOP_BAR: "system-setting/type/agent-dashboard-top-bar",
  UPDATE: (id: string) => `/system-setting/${id}`,
  GET_USER_SUSPEND: "/user-suspend",
  UPDATE_USER_SUSPEND: (id: string) => `/user-suspend/${id}`,
  DELETE_USER_SUSPEND: (id: string) => `/user-suspend/${id}`,
  CREATE_USER_SUSPEND: "/user-suspend",
  UPDATE_CALCULATOR_POLICY: "/system-setting/type/calculator-formula",
  GET_CALCULATOR_POLICY: "/system-setting/type/calculator-formula",
});

export enum SettingSystemType {
  KILL_SWITCH = "kill-switch",
  AGENT_DASHBOARD_TOP_BAR = "agent-dashboard-top-bar",
  CALCULATOR_FORMULA = "calculator-formula",
}
